export enum BookingRuleEnum {
  Luggage = 0,
  Ticket = 1,
}
